<template>
  <v-app>
    <v-main>
      <prognosen-widget />
    </v-main>
    <!-- Copyright (c) 2000-2021 etracker GmbH. All rights reserved. -->

    <!-- This material may not be reproduced, displayed, modified or distributed -->

    <!-- without the express prior written permission of the copyright holder. -->

    <!-- etracker tracklet 5.0 -->

    <script type="application/javascript">
  // var et_pagename = "";

  // var et_areas = "";

  // var et_tval = 0;

  // var et_tsale = 0;

  // var et_tonr = "";

  // var et_basket = "";
    </script>

    <script
      id="_etLoader"
      type="application/javascript"
      charset="UTF-8"
      data-block-cookies="true"
      data-respect-dnt="true"
      data-secure-code="U6V4r3"
      src="//code.etracker.com/code/e.js"
      async
    ></script>

    <!-- etracker tracklet 5.0 end -->
  </v-app>
</template>

<script>
import PrognosenWidget from "./components/PrognosenWidget.vue";

export default {
  components: { PrognosenWidget },
};
</script>
